(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var localPreviewHosts = ['localhost', '127.0.0.1', '0.0.0.0', '::1', '[::1]'];

  function getLocalLanguagePath(languageCode) {
    var path = window.location.pathname;

    if (languageCode === 'ja') {
      if (path === '/ja' || path.indexOf('/ja/') === 0) return path;
      return path === '/' ? '/ja' : '/ja' + path;
    }

    if (languageCode === 'en') {
      if (path === '/ja') return '/';
      if (path.indexOf('/ja/') === 0) return path.slice(3) || '/';
    }

    return path;
  }

  function initLocalLanguageToggle(toggle) {
    if (!toggle || toggle.dataset.wasuiLocalLanguageReady === 'true') return;

    toggle.dataset.wasuiLocalLanguageReady = 'true';
    toggle.addEventListener('click', function (event) {
      if (localPreviewHosts.indexOf(window.location.hostname) === -1) return;

      event.preventDefault();
      var nextPath = getLocalLanguagePath(toggle.value);
      window.location.assign(nextPath + window.location.search + window.location.hash);
    });
  }

  function getAnimatedItems(drawer) {
    var logo = drawer.querySelector('.wasui-header__drawer-logo');
    var links = Array.prototype.slice.call(drawer.querySelectorAll('.wasui-header__drawer-menu a'));
    var languageToggle = drawer.querySelector('.wasui-language-toggle--mobile');
    var socialItems = Array.prototype.slice.call(drawer.querySelectorAll('.wasui-header__drawer-social > *'));

    return [logo].concat(links, [languageToggle], socialItems).filter(Boolean);
  }

  function initDrawer(drawer) {
    if (!drawer || drawer.dataset.wasuiMenuReady === 'true') return;

    var toggle = drawer.querySelector('.wasui-header__drawer-toggle');
    var panel = drawer.querySelector('.wasui-header__drawer-panel');
    if (!toggle || !panel) return;

    drawer.dataset.wasuiMenuReady = 'true';

    function setExpanded(isExpanded) {
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      toggle.setAttribute('aria-label', isExpanded ? 'Close navigation' : 'Open navigation');
    }

    function openMenu() {
      drawer.setAttribute('open', '');
      setExpanded(true);

      if (!window.gsap || reducedMotion.matches) return;

      var items = getAnimatedItems(drawer);
      window.gsap.killTweensOf([panel].concat(items));
      window.gsap.set(panel, { autoAlpha: 0, y: -14 });
      window.gsap.set(items, { autoAlpha: 0, y: 16 });

      window.gsap
        .timeline({ defaults: { ease: 'power2.out' } })
        .to(panel, { autoAlpha: 1, y: 0, duration: 0.32 })
        .to(items, { autoAlpha: 1, y: 0, duration: 0.34, stagger: 0.055 }, '-=0.16');
    }

    function closeMenu(animate) {
      setExpanded(false);

      if (!window.gsap || reducedMotion.matches || animate === false) {
        drawer.removeAttribute('open');
        return;
      }

      var items = getAnimatedItems(drawer);
      window.gsap.killTweensOf([panel].concat(items));

      window.gsap
        .timeline({
          defaults: { ease: 'power2.inOut' },
          onComplete: function () {
            drawer.removeAttribute('open');
            window.gsap.set([panel].concat(items), { clearProps: 'all' });
          },
        })
        .to(items, { autoAlpha: 0, y: -8, duration: 0.18, stagger: { each: 0.025, from: 'end' } })
        .to(panel, { autoAlpha: 0, y: -14, duration: 0.24 }, '-=0.08');
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();

      if (drawer.hasAttribute('open')) {
        closeMenu(true);
      } else {
        openMenu();
      }
    });

    drawer.querySelectorAll('.wasui-header__drawer-panel a').forEach(function (link) {
      link.addEventListener('click', function () {
        if (drawer.hasAttribute('open')) closeMenu(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.hasAttribute('open')) {
        closeMenu(true);
        toggle.focus();
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.wasui-header__drawer').forEach(initDrawer);
    (scope || document)
      .querySelectorAll('.wasui-language-toggle__link[name="language_code"]')
      .forEach(initLocalLanguageToggle);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
